import styled from 'styled-components';

export const Container = styled.div`
  margin: auto;
  padding: ${props => props.theme.spacing(14, 6)};
  max-width: 560px;
`;

export const HeadingContainer = styled.div`
  margin: ${props => props.theme.spacing(0, 0, 10, 0)};
`;
